import React, { useState } from 'react';
import { Pressable, Text, View } from 'react-native';
import { useQuery, useMutation } from '@apollo/client';

import DataState from 'app/src/components/DataState';
import AuthContext from 'app/src/contexts/AuthContext';
import DataTable from '@preflighttech/preflight-tables';
import Filter from 'app/src/elements/Filter';
import { ResetSettings } from 'app/src/elements/Pagination/ResetSettings';
import {
  MainContainer,
  ContentContainer,
  PageTitle,
  LinkContainer,
  LinkSpace,
} from 'app/src/elements';
import Modal from 'app/src/elements/Modal';
import styled from 'styled-components/native';
import { elGray, elRed } from '../../../styles/colors';
import { styles, cardStyles } from '../../Reports';
import TrialBalanceImport from './TrialBalanceImport';
import TransactionJournalImport from './TransactionJournalImport';
import { FILE_UPLOADS_WITH_COUNT } from './queries';
import { Link } from 'app/src/utils/routing';

const ImportContainer = styled(View)`
  border: 1px solid black;
  border-radius: 10px;
  background-color: ${elGray};
  padding: 20px;
  min-height: 400px;
`;

const ImportButtonContainer = styled(View)`
  display: flex;
  flex-direction: row;
  gap: 50px;
  margin-top: 30px;
`;

const ImportButton = styled(Pressable)`
  border: 1px solid ${elRed};
  border-radius: 5px;
  padding: 10px;
  background-color: ${elRed};
  justify-content: center;
  align-items: center;
  max-height: 60px;
  min-width: 25%;
`;

const ImportButtonText = styled(Text)`
  font-weight: bold;
  font-size: 20px;
  color: #fff;
`;

const Import = () => {
  const [importModal, setImportModal] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [type, setType] = useState('Quickbooks Trial Balance');
  const [filterOptions, setFilterOptions] = useState();
  const [filters, setFilters] = useState({});
  const [settings, setSettings] = useState({});
  const queryVariables = {
    filterColumns: [],
    filterNames: [],
    scopes: ['quickbooks_imports', 'ordered_by_newest'],
  };

  const setFilter = (key, value) => {
    const currentFilters = {...filters};
    currentFilters[key] = value;
    setFilters(currentFilters);
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value) {
      queryVariables.filterColumns.push(key);
      queryVariables.filterNames.push(value);
    }
  });

  const columns = [
    {
      key: 'name',
      label: 'Name',
      // width: '20%',
      content: (entry) => {
        return entry.entry.name
      }
    },
    {
      key: 'file',
      label: 'File',
      content: (entry) => {
        return (
          <Link to={entry.entry.fileUrl}>
            <Text>Download</Text>
          </Link>
        )
      }
    },
    {
      key: 'functions',
      label: 'Functions',
      // width: '15%',
      // minViewportWidth: 1000,
      content: (entry) => {
        return (
          <div style={{display: 'inline-flex'}}>

          </div>
        )
      }
    }
  ]

  return (
    <MainContainer>
      <View style={styles.container}>
        <TrialBalanceImport refetch={refetch} />
        <TransactionJournalImport refetch={refetch} />
      </View>
      <ContentContainer>
        <Text style={{fontWeight: 'bold', fontSize: '18px'}}>
          Previous Imports
        </Text>
        <DataTable.Gql
          setRefetch={setRefetch}
          query={FILE_UPLOADS_WITH_COUNT}
          queryName='fileUploadsWithCount'
          columns={columns}
          // buttons={buttons}
          lengthMenu={ [10, 25, 50, 'All'] }
          dataUpdated={data => setFilterOptions(data?.fileUploadsWithCount)}
          htmlTable
          queryVariables={queryVariables}
        />
      </ContentContainer>
    </MainContainer>
  )
}

export default Import;